import React from 'react';

// Deux familles de boutons cohabitent dans l'app : « mkt » (site vitrine,
// classe .mkt-btn) et « admin » (espace mariage, classe .modern-btn). Ce
// composant les unifie sans toucher au CSS existant.
type ButtonUi = 'mkt' | 'admin';
type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  ui?: ButtonUi;
  variant?: ButtonVariant;
  full?: boolean; // pleine largeur (mkt)
  small?: boolean; // compact (admin)
}

const Button: React.FC<ButtonProps> = ({
  ui = 'admin',
  variant,
  full = false,
  small = false,
  className = '',
  type = 'button',
  children,
  ...rest
}) => {
  const classes = [
    ui === 'mkt' ? 'mkt-btn' : 'modern-btn',
    variant,
    full && ui === 'mkt' ? 'full' : '',
    small && ui === 'admin' ? 'small' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
};

export default Button;
